export default "__VITE_ASSET__DZH8iAPd__"